import { FC } from "react"

import { useTranslation } from "react-i18next"

import { LabeledInput } from "components/inputs/LabeledInput"
import { SectionCard } from "components/settings/SectionCard"

import { TEMPLATE_FIELDS } from "./constants"
import { FormState, TemplateFormFields } from "./types"

interface TemplatesSectionProps {
  form: FormState
  saving: boolean
  onTemplateChange: (key: keyof TemplateFormFields, value: string) => void
}

export const TemplatesSection: FC<TemplatesSectionProps> = ({ form, saving, onTemplateChange }) => {
  const { t } = useTranslation("translation", { useSuspense: false })

  return (
    <SectionCard title={t("settings.customerio.templates.title")} description={t("settings.customerio.templates.description")}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {TEMPLATE_FIELDS.map((key) => (
          <LabeledInput
            key={key}
            id={`cio-tmpl-${key}`}
            label={t(`settings.customerio.templates.fields.${key}`)}
            value={form.transactionalTemplates[key]}
            onChange={(v) => onTemplateChange(key, v)}
            disabled={saving}
            placeholder={t("settings.customerio.templates.placeholder")}
          />
        ))}
      </div>
    </SectionCard>
  )
}
